// ENVIRONMENT

// ANGULAR
import { inject, Injectable } from '@angular/core';

// SERVICES

// RxJS 6
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  WHChecklistDefinitionPreviewStoreActionTypes,
} from './w-h-checklist-definition-preview-store.actions';

// RxJS 6

@Injectable()
export class WHChecklistDefinitionPreviewStoreEffects {
  private actions$ = inject(Actions);

  getWHChecklistDefinitionPreviewDtoWithParams$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        WHChecklistDefinitionPreviewStoreActionTypes.GetWHChecklistDefinitionPreviewDtoWithParams,
      ),
    );
  });
}
